import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ITabs } from '@devinforius/i-navigation';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UserDto } from '@shared/interfaces/dtos/users';
import { Destinataire } from '@shared/models/destinataire';
import { ServicesService } from '@shared/services/services.service';
import { ButtonsGroup } from '@shared/types/dev';
import { CheckableItem } from '@shared/types/dtos';
import { ToastrService } from 'ngx-toastr';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormOptions } from 'src/app/common/models/form-options';
import { IContactService } from 'src/app/core/services/i-contact.service';
import { iAdminService } from 'src/app/core/services/iAdmin.service';
import { IDelibeGlobalService } from 'src/app/core/services/idelibe/global.service';
import * as _ from 'underscore';
import * as async from 'async';
import { FormControl } from '@angular/forms';
import { FormValidators } from '@shared/utils';

declare let $: any;

@Component({
  selector: 'app-add-recipients',
  templateUrl: './add-recipients.component.html',
  styleUrl: './add-recipients.component.scss',
})
export class AddRecipientsComponent {
  private readonly servicesService = inject(ServicesService);
  private readonly formOptions = inject(FormOptions);

  public filteredUsers: Array<any> = [];
  public isServiceMode: boolean;
  public actualRecipients: any[] = [];

  public tabItems = [
    { header: 'Utilisateurs', value: 'users', valueBadge: 0 }, // this.users.length
    { header: 'Services / Groupes', value: 'services&groups', valueBadge: 0 }, // this.services_groups.length
    { header: 'Destinataires libres', value: 'free', valueBadge: null },
  ];

  public readonly activeRecipientTab = signal<'users' | 'contacts' | 'groups' | 'services' | 'freeRecipients'>('users');
  public readonly recipientsTabs = signal<ITabs[]>([
    {
      header: 'Utilisateurs',
      id: 'users',
    },
    {
      header: 'Contacts',
      id: 'contacts',
    },
    {
      header: 'Groupes',
      id: 'groups',
    },
    {
      header: 'Services',
      id: 'services',
    },
    {
      header: 'Destinataires libres',
      id: 'freeRecipients',
    },
  ]);
  public searchString: string = '';
  public freeRecipient: string = '';
  public message = new FormControl<string | null>('', [FormValidators.minLength(5)]);
  public tabNewRecipient: any = [];
  public col = [
    {
      field: 'name',
      header: 'Nom',
    },
  ];
  public contactId: number;
  public transferMode: boolean = false;
  public tabCurrentSelected: number = 0;
  public userLoaded: boolean = false;

  public userAlreadySelected: Array<any>;
  public serviceAlreadySelected: Array<any>;

  public users: any[] = [];
  public contacts: any[] = [];
  public services: any[] = [];
  public selectedItems: any[] = [];
  public selectedContacts: any[] = [];
  public selectedServices_groups: any[] = [];
  public selectedUsers: any[] = [];
  public groups: any = [];
  public services_groups: any[] = [];
  public contactArray: Array<any> = [];
  public serviceArray: Array<any> = [];
  public selectedGroups: Array<any> = [];
  public groupsArray: Array<any> = [];
  public usersArray: Array<any> = [];
  public typeContact: Array<any> = [];
  public searchTypeContact: number;
  public selectedTabs: any = null;
  public filteredGroups: Array<any> = [];
  public filteredContacts: Array<any> = [];
  public filteredServices: Array<any> = [];
  public modalReference: NgbModalRef;
  public contactChecked = [];
  public destinatairesNamePresent: string = '';
  public recipientsNames: Array<any> = [];
  public freeRecipientArray: Array<any> = [];
  private allUsersOptions: CheckableItem<UserDto>[] = [];
  private allContactsOptions: CheckableItem<any>[] = [];

  public destinataires: Array<Destinataire>;

  public readonly recipientsStatesButtonsGroup: ButtonsGroup = [
    {
      label: 'Tous',
      value: 'all',
      command: () => {
        this.filterUsersOrContactsByActivityState('all');
      },
    },
    {
      label: 'Actifs',
      value: 'active',
      command: () => {
        this.filterUsersOrContactsByActivityState('active');
      },
    },
    {
      label: 'Inactifs',
      value: 'inactive',
      command: () => {
        this.filterUsersOrContactsByActivityState('inactive');
      },
    },
  ];

  public getTttlRecipientsToAdd(): number {
    const ttl =
      (this.contactArray?.length ?? 0) +
      (this.usersArray?.length ?? 0) +
      (this.serviceArray?.length ?? 0) +
      (this.groupsArray?.length ?? 0) +
      (this.freeRecipientArray?.length ?? 0);
    return ttl;
  }

  constructor(
    private adminApi: iAdminService,
    private contactService: IContactService,
    private toastr: ToastrService,
    private dialogService: DialogService,
    public route: ActivatedRoute,
    public router: Router,
    private IDelibeGlobalService: IDelibeGlobalService,
    public ref: DynamicDialogRef
  ) {}

  ngOnInit() {
    this.userLoaded = false;
    this.getData();
    this.contactArray = [];
    this.usersArray = [];
    this.serviceArray = [];
    this.groupsArray = [];
  }

  private filterUsersOrContactsByActivityState(state: 'all' | 'active' | 'inactive'): void {
    switch (this.activeRecipientTab()) {
      case 'contacts': {
        this.contacts =
          state === 'all'
            ? [...this.allContactsOptions]
            : this.allContactsOptions.filter((contact) => contact.active === (state === 'active'));

        break;
      }
      case 'users': {
        this.users =
          state === 'all'
            ? [...this.allUsersOptions]
            : this.allUsersOptions.filter((user) => user.active === (state === 'active'));

        break;
      }
    }
  }

  private fetchServices(): void {
    this.servicesService.fetchServices().subscribe({
      next: (res) => {
        this.services = res.map((service) => ({ ...service, checked: false }));
      },
    });
  }

  getData() {
    async.waterfall([
      (cb) => {
        this.adminApi.getUserInfo().subscribe(
          (response: any) => {
            this.contactId = response.contactId;
            cb(null);
          },
          (error) => {
            console.error(error);
          }
        );
      },
      (cb) => {
        this.services_groups = [];
        this.IDelibeGlobalService.getGroupes().subscribe(
          (response) => {
            let tempServices = [];
            this.groups = response;
            this.groups.map((group) => {
              group.name = group.description;
              group.isGroup = 'oui';
              group.type === 'GROUPE';
              group.checked = false;
            });
            if (this.serviceAlreadySelected && this.serviceAlreadySelected.length > 0) {
              tempServices = this.services.filter(
                (service) => !this.serviceAlreadySelected.some((serviceSelected) => service.id === serviceSelected.id)
              );
            } else {
              tempServices = this.services;
            }
            // tempService = _.uniq(tempService, 'id');
            cb(null);
          },
          (error) => {
            console.error(error);
            this.toastr.error('Impossible de charger les groupes!');
          }
        );
      },
      (cb) => {
        this.adminApi.getContactTypeAdmin().subscribe(
          (response: any) => {
            response.map((typeContact) => {
              typeContact.label = typeContact.typeContact;
              typeContact.value = typeContact.id;
            });
            this.typeContact = response;
            cb(null);
          },
          (error) => {
            console.error(error);
            this.toastr.error('Impossible de charger les types de contact');
          }
        );
      },

      (cb) => {
        this.fetchServices();
        cb(null);
      },
      (cb) => {
        this.contactService.getUserWithDataAdmin().subscribe(
          (response: any) => {
            const temp = [];
            response.map((item) => {
              temp.push({
                name: item.contactForUser.prenom + ' ' + item.contactForUser.nom,
                nom: item.contactForUser.nom,
                prenom: item.contactForUser.prenom,
                typeContactID: item.contactForUser.contactId,
                id: item.contactForUser.contactId,
                value: item.contactForUser.contactId,
                isUser: true,
                userId: item.userId,
                active: item.active,
                checked: false,
              });
            });
            this.users = (temp as any[]).filter((user) => user.active);
            sessionStorage.setItem('recipients-users', JSON.stringify(this.users));
            cb(null);
          },
          (error) => {
            console.error(error);
            this.toastr.error('Impossible de charger les types de contact');
          }
        );
      },
      (cb) => {
        this.getTabItems();
        this.userLoaded = true;
        cb(null);
      },
    ]);
  }

  public onActiveTabChange(tabId: 'users' | 'contacts' | 'groups' | 'services' | 'freeRecipients'): void {
    this.activeRecipientTab.set(tabId);
    this.selectedTabs = tabId;
  }

  private setCheckState(
    target: 'users' | 'contacts' | 'groups' | 'services' | 'freeRecipients',
    checkedElements: any[]
  ): void {
    const checkMap = (element) => {
      const foundElement = checkedElements.find((checkedElement) => checkedElement.id === element.id);

      return { ...element, checked: foundElement?.checked ?? false };
    };

    switch (target) {
      case 'contacts': {
        this.contacts = this.contacts.map(checkMap);
        break;
      }
      case 'services': {
        this.services = this.services.map(checkMap);
        break;
      }
      case 'groups': {
        this.groups = this.groups.map(checkMap);
        break;
      }
      case 'users': {
        this.users = this.users.map(checkMap);
        break;
      }
    }
  }

  public onRecipientCheck(selectedRecipients: any[]): void {
    switch (this.activeRecipientTab()) {
      case 'contacts': {
        this.contactArray = selectedRecipients;
        this.setCheckState('contacts', selectedRecipients);
        break;
      }
      case 'services': {
        this.serviceArray = selectedRecipients;
        this.setCheckState('services', selectedRecipients);
        break;
      }
      case 'groups': {
        this.groupsArray = selectedRecipients;
        this.setCheckState('groups', selectedRecipients);
        break;
      }
      case 'users': {
        this.usersArray = selectedRecipients;
        this.setCheckState('users', selectedRecipients);
        break;
      }
    }
  }

  public getTabItems() {
    this.recipientsTabs.set([
      {
        header: 'Utilisateurs',
        id: 'users',
        count: this.users.length,
        active: true,
      },

      {
        header: 'Groupes',
        id: 'groups',
        count: this.groups.length,
      },
      {
        header: 'Services',
        id: 'services',
        count: this.formOptions.services().length,
      },
      {
        header: 'Destinataires libres',
        id: 'freeRecipients',
      },
    ]);

    this.switchTabs(this.tabItems[0]);
  }

  switchTabs(e) {
    this.userLoaded = false;
    this.filteredUsers = [];
    this.searchTypeContact = null;
    const tabCurrentSelected = e;
    this.selectedTabs = e;
    tabCurrentSelected.value === 'contacts'
      ? (this.col = [
          { field: 'name', header: 'Nom' },
          { field: 'typeContactDesc', header: 'Type' },
        ])
      : '';
    this.filterBy(tabCurrentSelected);
  }

  filterBy(e) {
    const value = e.value;
    if (this.isServiceMode) {
      this.isServiceMode = false;
    }
    this.filteredUsers = [];
    this.filteredContacts = [];
    this.filteredServices = [];
    this.filteredGroups = [];
    switch (value) {
      case 'contacts':
        this.isServiceMode = false;
        this.filteredUsers = [];
        this.filteredGroups = [];
        this.filteredServices = [];
        this.filteredContacts = this.contacts.filter((x) => !x.nePlusUtiliser);
        this.filteredContacts.map((item) => {
          if (item.name) {
            item.name = item.name.trimStart();
            item.active = !item.nePlusUtiliser;
          }
        });
        this.tabItems.find((x) => x.value === 'contacts').valueBadge = this.contacts.length;
        break;
      case 'all':
        this.isServiceMode = false;
        this.filteredUsers = this.users;
        this.filteredUsers.map((item) => {
          if (item.name) {
            item.name = item.name.trimStart();
          }
        });
        this.filteredUsers.push(this.services);
        break;
      case 'services':
        this.filteredUsers = [];
        this.filteredContacts = [];
        this.filteredGroups = [];
        this.filteredServices = this.services;
        this.tabItems.find((x) => x.value === 'services').valueBadge = this.services.length;
        this.isServiceMode = true;

        break;
      case 'groups':
        this.filteredUsers = [];
        this.filteredContacts = [];
        this.filteredServices = [];
        this.filteredGroups = this.groups;
        this.filteredGroups.map((item) => {
          if (item.name) {
            item.name = item.name.trimStart();
          }
        });
        this.tabItems.find((x) => x.value === 'groups').valueBadge = this.groups.length;
        this.isServiceMode = false;

        break;
      case 'users':
        this.isServiceMode = false;
        this.filteredUsers = [];
        this.filteredContacts = [];
        this.filteredGroups = [];
        this.filteredUsers = this.users;
        this.filteredUsers.map((item) => {
          if (item.name) {
            item.name = item.name.trimStart();
          }
        });

        this.filteredUsers = [...this.filteredUsers];

        this.tabItems.find((x) => x.value === 'users').valueBadge = this.users.length;
        break;
      case 'free':
        this.filteredUsers = [];
        break;
    }
    this.userLoaded = true;
  }

  /**
   * Add a free recipient into selectedItems
   * @param form data receive by the form
   */
  addRecipientFree() {
    if (this.freeRecipient !== '' && this.freeRecipient !== null) {
      this.freeRecipientArray = [];
      this.freeRecipientArray = this.freeRecipient.split(';');
      if (this.freeRecipientArray.length > 0) {
        this.freeRecipientArray.map((recipient) => {
          this.tabNewRecipient.push({ checked: true, name: recipient, id: recipient });
          this.selectedItems.push({ checked: true, name: recipient, id: recipient });
        });
      }
      if (this.tabNewRecipient.length >= 1) {
        this.tabNewRecipient = _.uniq(this.tabNewRecipient, 'name');
      }
    }
  }

  /**
   * Add selectedItems to mail Destinataire => send it to parent
   */
  addUsers() {
    if (this.getTttlRecipientsToAdd() === 0) return;

    const data = {
      contactArray: this.contactArray,
      usersArray: this.usersArray,
      groupsArray: this.groupsArray,
      serviceArray: this.serviceArray,
      freeRecipientArray: this.freeRecipientArray,
      message: this.message.value ?? null,
    };
    this.ref.close(data);
  }

  closeActionModal() {
    this.ref.close();
    sessionStorage.removeItem('showModalDestinataire');
  }

  openNewContact() {
    //!TODO INJECTER LE NOUVEAU FORMULAIRE DE CONTACT
    // const ref = this.dialogService.open(ContactNewComponent, {
    //   styleClass: 'super-compos-modal-content',
    //   dismissableMask: false,
    //   width: '70vw',
    //   closable: false,
    //   showHeader: false,
    //   baseZIndex: 1000,
    //   data: {
    //     caller: 'linked',
    //     hideSwitch: false,
    //     companyMode: false,
    //   },
    // });
    // $(document).ready(function () {
    //   const modalContent: any = $('.modal-content');
    //   modalContent.draggable({
    //     handle: '.modal-header',
    //     revert: false,
    //     revertDuration: 300,
    //   });
    // });
    // ref.onClose.subscribe((value) => {
    //   if (value) {
    //     const temp = this.filteredContacts;
    //     this.filteredContacts = [];
    //     setTimeout(() => {
    //       temp.push({
    //         id: value.id,
    //         label: (value.prenom ? value.prenom : '') + ' ' + (value.nom ? value.nom : ''),
    //         name: (value.prenom ? value.prenom : '') + ' ' + (value.nom ? value.nom : ''),
    //         nePlusUtiliser: value.nePlusUtiliser,
    //         nom: value.nom,
    //         prenom: value.prenom,
    //         typeContact: null,
    //         typeContactID: value.typeContactId,
    //         typeContactName: null,
    //         typeSociete: value.typeSociete,
    //         value: value.id,
    //       });
    //       this.filteredContacts = temp;
    //     }, 1500);
    //   }
    // });
  }
}
